<template>
  <div id="app" class="colorDarkGrey">
    <div class="modalWebcams" id="modalWebcam" onclick="document.getElementById('modalWebcam').style.display = 'none'">
      <img class="modalCloseIcon" src="/img/vue_svg/close_white.svg" />
      <div id="webcamContainer">
        <img alt="kamera" id="webcamPicture" />
      </div>
    </div>
    <div class="modalWebcams" id="modalDwista" onclick="document.getElementById('modalDwista').style.display = 'none'">
      <img class="modalCloseIcon" src="/img/vue_svg/close_white.svg" />
      <div id="dwistaContainer">
        <img alt="dwista" id="dwistaPicture" />
      </div>
    </div>
    <!-- margintop15 -->
    <notifications :style="{ marginTop: device === 'XS' ? '60px' : '115px' }" group="notification" class="marginright15"
      :max="2">
      <template slot="body" slot-scope="props">
        <!-- <div
          :class="[props.item.type === 'success' ? 'borderBlue colorBlue backgroundLightBlue' : 'borderRed colorRed backgroundLightRed'
                  ,'borderWidth1', 'borderStyleSolid', 'padding10', 'marginbottom5', 'displayflex', 'flexbetween']">

            <div class="selfAlignCenter" v-html="props.item.text"></div>
            <a class="close selfAlignCenter">
              <SVGIcon name="close" size="small" @click.native="props.close" />
            </a>
        </div>-->
        <div class="colorWhite marginbottom15 displayflex">
          <a :class="['padding10 borderRadiusLeft5 borderWidth1 borderStyleSolid'
            , props.item.type === 'success' ? 'backgroundBlue borderBlue' : 'backgroundRed borderRed']">
            <SVGIcon class="cursor-pointer" name="close_white" size="small" @click.native="props.close" />
          </a>
          <div
            class="padding10 width100 selfAlignCenter backgroundDarkDarkGrey borderRadiusRight5 borderWidth1 borderStyleSolid borderDarkDarkGrey"
            v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>
    <div v-if="isLoading" class="loader"></div>
    <Header />
    <Map ref="map" />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Map from './components/Map.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'app',
  data: function () {
    return {
      loadNewstickerInterval: null
    };
  },
  components: {
    Header,
    Map,
    Footer
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    device() {
      return this.$store.state.device;
    }
  },
  mounted() {
    window.addEventListener('resize', this.getDevice);
    this.loadNewsticker();
    this.loadNewstickerInterval = setInterval(
      this.loadNewsticker,
      3 * 60 * 1000
    );
  },
  methods: {
    getDevice() {
      this.$store.commit('setDevice');
    },
    loadNewsticker() {
      this.$store.dispatch('loadNewsticker');
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getDevice);
    clearInterval(this.loadNewstickerInterval);
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Kalam");
@import url("https://fonts.googleapis.com/css?family=Droid+Sans");
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300"); */

/* latin */
@font-face {
  font-family: 'Droid Sans';
  font-style: normal;
  font-weight: 400;
  src: url(../public/fonts/DroidSans.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  background: #ffffff;
  line-height: 1.42857143;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}

#app {
  height: 100%;
  font-family: "Droid Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.loader {
  border: 8px solid #9ba0a4;
  border-top: 8px solid #1a70b8;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.25s linear infinite;
  position: absolute;
  left: calc(50% - 30px);
  top: 20px;
  background-color: #fafafa;
}

@media (max-width: 768px) {
  .loader {
    width: 30px;
    height: 30px;
    top: 15px;
    border-width: 4px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

input::placeholder {
  color: #64b5f6;
}

.colorBlue,
.leaflet-container a {
  color: #64b5f6;
}

.colorDarkBlue {
  color: #1a70b8;
}

.colorWhite {
  color: #fafafa;
}

.colorDarkGrey {
  color: #363d3f;
}

.colorLightGrey {
  color: #90989c;
}

.colorRed {
  color: #dc2e33;
}

.colorYellow {
  color: #ffd900;
}

.colorLightGreen {
  color: #98cb00;
}

.colorBlack {
  color: #000000;
}

.borderBlue {
  border-color: #64b5f6;
}

.borderGrey {
  border-color: #eaeaea;
}

.borderDarkGrey {
  border-color: #9ba0a4;
}

.borderDarkDarkGrey {
  border-color: #6c7a7f;
}

.borderRed {
  border-color: #dc2e33;
}

.borderYellow {
  border-color: #ffd900;
}

.borderLightGreen {
  border-color: #98cb00;
}

.borderWhite {
  border-color: #fafafa;
}

.borderRadius5 {
  border-radius: 5px;
}

.borderRadius10 {
  border-radius: 10px;
}

.borderRadius30 {
  border-radius: 30px;
}

.borderRadiusRight5 {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.borderRadiusRight10 {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.borderRadiusRight05 {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}

.borderRadiusLeft5 {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.borderRadiusLeft10 {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.borderWidth1 {
  border-width: 1px;
}

.borderBottomWidth1 {
  border-bottom-width: 1px;
}

.borderBottomWidth2 {
  border-bottom-width: 2px;
}

.borderTopWidth1 {
  border-top-width: 1px;
}

.borderStyleSolid {
  border-style: solid;
}

.borderBottomStyleSolid {
  border-bottom-style: solid;
}

.borderTopStyleSolid {
  border-top-style: solid;
}

.backgroundBlue {
  background-color: #64b5f6;
}

.backgroundBlue50 {
  background-color: rgba(100, 180, 246, 0.5);
}

.backgroundLightBlue {
  background-color: #ddefff;
}

.backgroundDarkBlue {
  background-color: #1a70b8;
}

.backgroundGrey {
  background-color: #f0f6f8;
}

.backgroundLightGrey {
  background-color: #90989c;
}

.backgroundLightGrey50 {
  background-color: rgba(144, 152, 156, 0.5);
}

.backgroundDarkGrey {
  background-color: #9ba0a4;
}

.backgroundDarkDarkGrey {
  background-color: #6c7a7f;
}

.backgroundWhite {
  background-color: rgb(255, 255, 255);
}

.backgroundLightRed {
  background-color: #ffe2e3;
}

.backgroundYellow {
  background-color: #ffd900;
}

.backgroundLightGreen {
  background-color: #98cb00;
}

.backgroundRed {
  background-color: #dc2e33;
}

.cursor-pointer {
  cursor: pointer;
}

.icon {
  max-width: 36px;
  max-height: 36px;
}

.svgIcon {
  width: 36px;
  height: 36px;
}

.leaflet-div-icon {
  background: none;
  border: none;
}

h3 {
  font-size: 18px;
  font-weight: bold;
}

p {
  margin: 0 0 10px;
}

.width100 {
  width: 100%;
}

.width95 {
  width: 95%;
}

.width84 {
  width: 84%;
}

.widthFit {
  width: fit-content;
}

.maxWidth50 {
  max-width: 50px;
}

.height50 {
  height: 50%;
}

.margin5 {
  margin: 5px;
}

.margin0_20 {
  margin: 0 20px;
}

.margin20_0 {
  margin: 20px 0;
}

.margin20_40 {
  margin: 20px 40px;
}

.marginleft5 {
  margin-left: 5px;
}

.marginleft15 {
  margin-left: 15px;
}

.marginleft20 {
  margin-left: 20px;
}

.marginleft50 {
  margin-left: 50px;
}

.margintop5 {
  margin-top: 5px;
}

.margintop10 {
  margin-top: 10px;
}

.margintop15 {
  margin-top: 15px;
}

.margintop20 {
  margin-top: 20px;
}

.marginright15 {
  margin-right: 15px;
}

.marginright30 {
  margin-right: 30px;
}

.marginbottom5 {
  margin-bottom: 5px;
}

.marginbottom15 {
  margin-bottom: 15px;
}

.marginbottom20 {
  margin-bottom: 20px;
}

.padding5 {
  padding: 5px;
}

.padding10 {
  padding: 10px;
}

.padding15 {
  padding: 15px;
}

.padding20 {
  padding: 20px;
}

.paddingtop10 {
  padding-top: 10px;
}

.paddingright15 {
  padding-right: 15px;
}

.fontweight600 {
  font-weight: 600;
}

/* MW 2022-11-08 Google Fonts ersetzt */
/* .fontKalam {
  font-family: "Kalam", cursive;
} */

.fontsize22 {
  font-size: 22px;
}

.fontsize20 {
  font-size: 20px;
}

.fontsize18 {
  font-size: 18px;
}

.fontsize16 {
  font-size: 16px;
}

.fontsize14 {
  font-size: 14px;
}

.fontsize13 {
  font-size: 13px;
}

.lineHeight20 {
  line-height: 20px;
}

.displayflex {
  display: flex;
}

.displayflexColumn {
  display: flex;
  flex-direction: column;
}

.flexbetween {
  justify-content: space-between;
}

.flexend {
  justify-content: flex-end;
}

.flexcenter {
  justify-content: center;
}

.flexaround {
  justify-content: space-around;
}

.flexnowrap {
  flex-wrap: nowrap;
}

.flexwrap {
  flex-wrap: wrap;
}

.selfAlignCenter {
  display: flex;
  flex-direction: column;
  align-self: center;
}

.textcenter {
  text-align: center;
}

.rotate45 {
  transform: rotate(45deg);
}

.rotate90 {
  transform: rotate(90deg);
}

.rotate180 {
  transform: rotate(180deg);
}

.rotate270 {
  transform: rotate(270deg);
}

input {
  border: none;
  width: 100%;
  font-family: "Droid Sans", sans-serif;
  font-size: 16px;
  outline: none;
}

input.borderBottom {
  height: 40px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.svgIcon {
  width: 36px;
  height: 36px;
}

.close {
  opacity: 1 !important;
}

.modalWebcams {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  overflow: hidden;
  background-color: #000;
  -webkit-transform: translate3d(0, 0, 0);
  display: none;
  cursor: pointer;
}

#webcamContainer {
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
}

#webcamContainer img {
  max-width: 100%;
}

#dwistaContainer {
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  max-width: 100%;
}

#dwistaContainer img {
  max-width: 100%;
}

.modalCloseIcon {
  position: absolute;
  top: 10px;
  right: 10px;
}

.impact-list {
  display: flex;
  align-items: left;
}

.impact-symbol {
  padding: 1px;
}
</style>
